// extracted by mini-css-extract-plugin
export default {"closeIcon":"close-dialog-button_closeIcon__mQ0S5"};